import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import MealPrep from "@/pages/MealPrep";
import Catering from "@/pages/Catering";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import Review from "@/pages/Review";
import Account from "@/pages/Account";
import AdminEnter from "@/pages/AdminEnter";
import AuthCallback from "@/pages/AuthCallback";
import Unsubscribe from "@/pages/Unsubscribe";
import { SitePhotosProvider } from "@/lib/sitePhotos";
import { CustomerAuthProvider } from "@/lib/auth";
import { trackPageview } from "@/lib/activity";

const AppRoutes = () => {
  const location = useLocation(); // read the fragment here (reactive), not from window.location
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/meal-prep" element={<MealPrep />} />
      <Route path="/catering" element={<Catering />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/admin/enter/:token" element={<AdminEnter />} />
      <Route path="/account" element={<Account />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/review/:token" element={<Review />} />
      <Route path="/unsubscribe/:token" element={<Unsubscribe />} />
    </Routes>
  );
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    trackPageview(pathname);
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <SitePhotosProvider>
        <CustomerAuthProvider>
        <ScrollToTop />
        <Navbar />
        <AppRoutes />
        <Footer />
        <Toaster position="top-center" richColors />
        </CustomerAuthProvider>
        </SitePhotosProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
